export default __webpack_public_path__ + "static/media/KOD0094-min.77e36a2c.webp";